import CheckboxMUI from './CheckboxMUI';

export default CheckboxMUI;
